module.exports = __webpack_public_path__ + "img/diamonds.420eb5a6.png";